module.exports = __webpack_public_path__ + "img/image.16be0b51.png";